export default __webpack_public_path__ + "9d6c356964d4a1ecf98b714ed9229773.png";